import { useAppSelector } from "../../app/hooks";
import Select from "./Select";
import { SimpleOption } from "./SimpleListbox";

interface SelectDevelopmentViewProps {
	value: string | number | undefined;
	setValue: (value: string | number | undefined) => void;
	simpleListBoxId: string;
	options?: SimpleOption[];
	label?: string;
	fieldClasses?: string;
	labelClasses?: string;
	simpleListBoxClasses?: string;
}

export function SelectDevelopmentView(props: SelectDevelopmentViewProps) {
	const { config } = useAppSelector((state) => state.site);
	return (
		<>
			{config?.isDevEnvironment && (
				<Select
					value={props.value}
					setValue={props.setValue}
					simpleListBoxId={props.simpleListBoxId}
					options={
						props.options ?? [
							{ value: "react", label: "React" },
							{ value: "raw", label: "Raw Data" },
						]
					}
					label={props.label}
					fieldClasses={`w-64 ${props.fieldClasses}`}
					labelClasses={props.labelClasses}
					simpleListBoxClasses={`w-full ${props.simpleListBoxClasses}`}
				/>
			)}
		</>
	);
}
